module.exports = __webpack_public_path__ + "img/New Mobil_4C-TM.e2048a15.png";